import { computed, Injectable, signal } from '@angular/core';
import { translations, type Locale, type Translations } from '../../../assets/i18n/translations';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  private readonly LOCALE_KEY = 'gozem_locale';

  readonly locale = signal<Locale>(this.loadLocaleFromStorage());
  readonly translations = computed<Translations>(() => translations[this.locale()]);

  private loadLocaleFromStorage(): Locale {
    if (typeof window === 'undefined') return 'fr';

    const stored = localStorage.getItem(this.LOCALE_KEY) as Locale | null;
    return stored && (stored === 'fr' || stored === 'en') ? stored : 'fr';
  }

  setLocale(locale: Locale): void {
    this.locale.set(locale);
    if (typeof window !== 'undefined') {
      localStorage.setItem(this.LOCALE_KEY, locale);
    }
  }

  toggleLocale(): void {
    const newLocale = this.locale() === 'fr' ? 'en' : 'fr';
    this.setLocale(newLocale);
  }
}
